module.exports = __webpack_public_path__ + "static/Lamentum6-67b286e8047a58715b4b7425eb0292c3.webp";